<template>
  <div
    class="page-header align-items-start min-vh-100"
    style="background-color: transparent"
  >
    <span class="mask opacity-6"></span>
    <div class="container my-auto">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-body">
              <img
                src="@/assets/img/logo.png"
                style="width: 40%; display: block; margin: 0 auto"
                alt=""
              />

              <form role="form" class="text-start mt-3">
                <div>
                  <div
                    class="input-group input-group-outline m-0 d-flex flex-column"
                  >
                    <label class="input-label">
                      <span
                        class="text-xs text-uppercase text-body font-weight-bolder"
                        >E-mail</span
                      >
                      <input
                        v-model="email"
                        type="email"
                        ref="email"
                        class="form-control default-bordered-input"
                        placeholder="Insira seu email"
                      />
                    </label>
                  </div>
                </div>

                <div>
                  <div
                    class="input-group input-group-outline m-0 d-flex flex-column"
                  >
                    <label class="input-label">
                      <span
                        class="text-xs text-uppercase text-body font-weight-bolder"
                        >Senha</span
                      >
                      <input
                        v-model="password"
                        type="password"
                        class="form-control default-bordered-input"
                        placeholder="Insira sua senha"
                        @keyup.enter="auth"
                      />
                    </label>
                  </div>
                </div>

                <div class="text-center">
                  <button
                    class="btn btn-icon btn-3 campaign-btn m-0"
                    type="button"
                    disabled
                    v-if="loading"
                  >
                    <span class="btn-inner--text btn-text">Aguarde...</span>
                  </button>
                  <button
                    class="btn btn-icon btn-3 campaign-btn m-0"
                    type="button"
                    @click.prevent="auth"
                    v-if="!loading"
                  >
                    <span class="btn-inner--text btn-text">Fazer login</span>
                  </button>
                </div>
                <p class="mt-4 text-sm text-center">
                  Ainda não tem conta?
                  <router-link
                    :to="{ name: 'SignUp', query: $route.query.affiliate_campaign ? { affiliate_campaign: $route.query.affiliate_campaign } : {} }"
                    class="text-success text-gradient font-weight-bold"
                    >Cadastre-se</router-link
                  >
                </p>
                <!-- ESQUECEU SENHA -->
                <p class="mt-4 text-sm text-center">
                  <button
                    class="btn btn-icon btn-3 more-btn m-0"
                    type="button"
                    @click.prevent="resetPassword"
                  >
                    <span class="btn-inner--text btn-text"
                      >Esqueceu sua senha?</span
                    >
                  </button>
                </p>
                <p class="mt-2 text-sm text-center">
                  <button
                    class="btn btn-icon btn-3 more-btn m-0"
                    type="button"
                    :disabled="loadingResend"
                    @click.prevent="resendVerification"
                  >
                    <span class="btn-inner--text btn-text">{{
                      loadingResend
                        ? "Reenviando..."
                        : "Reenviar confirmação (WhatsApp + e-mail)"
                    }}</span>
                  </button>
                </p>
                <p class="mt-4 text-sm text-center">
                  <small>v{{ appVersion }}</small>
                </p>
              </form>
            </div>
            <!-- MODAL 2FA -->
            <div v-if="twoFaModal" class="custom-modal-overlay">
              <div class="custom-modal-dialog">
                <div class="custom-modal-content">
                  <div class="custom-modal-header">
                    <h5 class="modal-title" id="twoFaModalLabel">
                      Autenticação de Dois Fatores
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      @click="twoFaModal = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body d-flex flex-column align-items-center">
                    <p v-if="twoFaData?.two_fa_method === 'totp'">
                      Abra o app autenticador e digite o código de 6 dígitos
                      gerado para a conta Rifa365.
                    </p>
                    <template v-else>
                      <p>
                        Um código de autenticação de dois fatores foi enviado para
                        o seu WhatsApp com final
                        <strong>{{ twoFaData?.last_4_digits }}</strong>
                        e para o e-mail da conta
                        <strong v-if="twoFaData?.email_hint">{{
                          twoFaData.email_hint
                        }}</strong
                        ><span v-else>cadastrado</span>. Por favor, insira o
                        código abaixo para continuar.
                      </p>
                      <div class="twofa-spam-notice" role="note">
                        <div class="twofa-spam-notice__icon" aria-hidden="true">
                          <i class="material-icons">mark_email_unread</i>
                        </div>
                        <div class="twofa-spam-notice__body">
                          <strong>Não encontrou o e-mail?</strong>
                          <p>
                            Em algumas contas o código cai na
                            <strong>lixeira</strong>,
                            <strong>spam</strong> ou
                            <strong>lixo eletrônico</strong>.
                            Verifique essas pastas e, se estiver lá, marque como
                            <strong>não é lixo eletrônico</strong>
                            para receber os próximos com mais facilidade.
                          </p>
                        </div>
                      </div>
                    </template>
                    <div
                      class="input-group input-group-outline m-0 d-flex flex-column"
                    >
                      <label class="input-label">
                        <span
                          class="text-xs text-uppercase text-body font-weight-bolder"
                          >Código de Autenticação</span
                        >
                        <input
                          v-model="twoFaCode"
                          type="text"
                          class="form-control default-bordered-input"
                          placeholder="Insira o código"
                          maxlength="6"
                          inputmode="numeric"
                          pattern="\d*"
                          @input="
                            twoFaCode = twoFaCode.replace(/\D/g, '').slice(0, 6)
                          "
                        />
                      </label>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="twoFaModal = false"
                    >
                      Fechar
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="verifyTwoFa"
                    >
                      Verificar Código
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthHttp from "@/http/AuthHttp.js";
import AffiliateHttp from "@/http/AffiliateHttp.js";
import LoggingMixin from "@/mixins/LoggingMixin";

import { mapMutations } from "vuex";

export default {
  name: "sign-in",
  mixins: [LoggingMixin],
  data() {
    return {
      twoFaModal: false,
      twoFaCode: "",
      twoFaData: null,
      twoFaBody: {
        id: null,
        two_fa_code: "",
      },
      appVersion: "",
      loading: false,
      loadingResend: false,
      email: "",
      password: "",
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  mounted() {
    this.appVersion = require("../../package.json").version;
    // Persistir affiliate_campaign no sessionStorage ao entrar na página
    const affiliateCampaign = this.$route.query.affiliate_campaign;
    if (affiliateCampaign) {
      sessionStorage.setItem("pending_affiliate_campaign", affiliateCampaign);
    }
    this.verifyAuth();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async redirectAfterLogin(user, token) {
      if (token) {
        this.$store.commit("setConfig", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }

      const campaignId =
        this.$route.query.affiliate_campaign ||
        sessionStorage.getItem("pending_affiliate_campaign");

      if (campaignId && user && user.role !== "ADMIN") {
        sessionStorage.removeItem("pending_affiliate_campaign");
        try {
          const res = await AffiliateHttp.joinCampaign(parseInt(campaignId, 10));
          const already = res.data && res.data.already_joined;
          this.$toast.add({
            severity: "success",
            summary: already ? "Você já é afiliado" : "Convite aceito!",
            detail: already
              ? "Seu link exclusivo está em Seja Afiliado."
              : "Agora você tem um link exclusivo para divulgar esta rifa.",
            life: 5000,
          });
        } catch (e) {
          const msg =
            (e.response && e.response.data && e.response.data.error) ||
            "Não foi possível aceitar o convite de afiliado.";
          this.$toast.add({
            severity: "warn",
            summary: "Convite de afiliado",
            detail: msg,
            life: 6000,
          });
        }
        this.$router.push({ path: "/minhas-afiliacoes" });
        return;
      }

      const next = String(this.$route.query.next || "");
      if (next === "/plans/pagamento") {
        const plan = String(this.$route.query.plan || "mensal").toLowerCase();
        this.$router.push({
          path: "/plans/pagamento",
          query: { plan: plan === "anual" ? "anual" : "mensal" },
        });
        return;
      }

      this.$router.push({ name: "Dashboard" });
    },
    async handleInputValue(event) {
      const { name, value } = event.target;
      this[name] = value;
    },
    async verifyAuth() {
      try {
        const token = this.$store.getters.token;
        const user = this.$store.getters.user;
        
        if (token && user) {
          const response = await AuthHttp.validateUser(token);

          if (response.status == 200) {
            await this.redirectAfterLogin(user, token);
          }
        }
      } catch (error) {
        console.error("Erro na verificação de autenticação:", error);
      }
    },
    async auth() {
      if (!this.email || !this.password) {
        this.$toast.add({
          severity: "warn",
          summary: "Preencha todos os campos.",
          detail:
            "Verifique se os campos estão preenchidos corretamente e tente novamente.",
          life: 3000,
        });
        return;
      }
      try {
        this.loading = true;
        const response = await AuthHttp.signIn({
          email: this.email,
          password: this.password,
        });
        if (response.status === 200) {
          if (response.data.two_fa) {
            this.twoFaModal = true;
            this.twoFaCode = "";
            this.twoFaData = response.data;
            this.twoFaBody.id = response.data.id;
            this.loading = false;
            return;
          }

          if (response.data.token) {
            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setUser", response.data.user);
            const role = response.data.user.role === "ADMIN" ? "administrador" : "usuário";
            this.$log.log("AUTH", "LOGIN", `${response.data.user.email} fez login no sistema como ${role}`);
            await this.redirectAfterLogin(response.data.user, response.data.token);
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Ocorreu um erro.",
            detail: "Usuário ou senha inválidos.",
            life: 3000,
          });
        }
        this.loading = false;
      } catch (error) {
        console.error("Login error object:", error);

        const status = error?.response?.status || error?.status;
        let e = "";
        if (error && typeof error === "object") {
          e =
            error.error ||
            (error.response && error.response.data
              ? error.response.data.error
              : "");
        }

        // HTTP 429 — rate limit
        if (status === 429) {
          this.$toast.add({
            severity: "warn",
            summary: "Muitas tentativas.",
            detail: "Aguarde 1 minuto antes de tentar novamente.",
            life: 6000,
          });
          this.loading = false;
          return;
        }

        if (e == "Account not verified") {
          this.$toast.add({
            severity: "error",
            summary: "Conta não confirmada",
            detail:
              "Enviamos o link para WhatsApp e e-mail. Se não recebeu, clique em Reenviar confirmação.",
            life: 9000,
          });
          this.loading = false;
          return;
        }

        if (e == "Account blocked") {
          this.$toast.add({
            severity: "error",
            summary: "Ocorreu um erro.",
            detail: "Sua conta foi bloqueada. Entre em contato com o suporte.",
            life: 3000,
          });
          this.loading = false;
          return;
        }

        this.$toast.add({
          severity: "error",
          summary: "Ocorreu um erro.",
          detail:
            e && typeof e === "string" ? e : "Usuário ou senha inválidos.",
          life: 3000,
        });
        this.loading = false;
      }
    },
    async verifyTwoFa() {
      if (!this.twoFaCode || this.twoFaCode.length !== 6) {
        this.$toast.add({
          severity: "warn",
          summary: "Código inválido.",
          detail: "O código deve conter 6 dígitos.",
          life: 3000,
        });
        return;
      }

      try {
        this.loading = true;
        this.twoFaBody.two_fa_code = this.twoFaCode;
        const response = await AuthHttp.signIn2FA(this.twoFaBody);
        if (response.status === 200) {
          if (response.data.token) {
            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setUser", response.data.user);

            const role = response.data.user.role === "ADMIN" ? "administrador" : "usuário";
            this.$log.log("AUTH", "LOGIN", `${response.data.user.email} fez login com 2FA como ${role}`);

            await this.redirectAfterLogin(response.data.user, response.data.token);
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Ocorreu um erro.",
            detail: "Código inválido. Tente novamente.",
            life: 3000,
          });
        }

        this.loading = false;
      } catch (error) {
        // HTTP 429 — rate limit
        const status = error?.response?.status || error?.status;
        const msg = error?.response?.data?.error || error?.error || "";

        if (status === 429) {
          this.$toast.add({
            severity: "warn",
            summary: "Muitas tentativas.",
            detail: "Aguarde 1 minuto antes de tentar novamente.",
            life: 6000,
          });
          this.loading = false;
          return;
        }

        if (msg === "2FA code expired") {
          this.$toast.add({
            severity: "warn",
            summary: "Código expirado.",
            detail: "O código de verificação expirou (válido por 10 minutos). Faça login novamente para receber um novo código.",
            life: 8000,
          });
          this.twoFaModal = false;
          this.loading = false;
          return;
        }

        this.$toast.add({
          severity: "error",
          summary: "Ocorreu um erro.",
          detail: msg || "Código inválido. Tente novamente.",
          life: 3000,
        });
        this.loading = false;
      }
    },
    async resendVerification() {
      if (!this.email) {
        this.$toast.add({
          severity: "warn",
          summary: "Digite seu e-mail.",
          detail: "Informe o e-mail da conta para reenviar a confirmação.",
          life: 3000,
        });
        this.$refs.email?.focus();
        return;
      }

      try {
        this.loadingResend = true;
        const response = await AuthHttp.resendVerification(this.email);
        if (response.status === 200) {
          this.$toast.add({
            severity: "success",
            summary: "Solicitação enviada",
            detail:
              "Se a conta existir e ainda precisar de confirmação, enviamos um novo link para WhatsApp e e-mail (válido por 48 horas).",
            life: 9000,
          });
        }
      } catch (error) {
        const e =
          error?.error ||
          error?.response?.data?.error ||
          "Não foi possível reenviar.";
        this.$toast.add({
          severity: "error",
          summary: "Erro ao reenviar",
          detail: typeof e === "string" ? e : "Tente novamente em instantes.",
          life: 5000,
        });
      } finally {
        this.loadingResend = false;
      }
    },
    async resetPassword() {
      if (!this.email) {
        this.$toast.add({
          severity: "warn",
          summary: "Digite seu email.",
          detail: "Digite seu email para recuperar sua senha.",
          life: 3000,
        });
        this.$refs.email.focus();
        return;
      }

      try {
        this.loading = true;
        const response = await AuthHttp.recoverPassword(this.email);
        if (response.status === 200) {
          this.$log.log("AUTH", "AÇÃO", `Solicitada recuperação de senha para o e-mail ${this.email}`);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso!",
            detail:
              "Enviamos o link de redefinição para o WhatsApp e para o e-mail cadastrados. Verifique os dois canais (incluindo spam) e siga as instruções.",
            life: 3000,
          });
        }
        this.loading = false;
      } catch (error) {
        let e = error.response.data.error;
        if (e == "Account not verified") {
          this.$toast.add({
            severity: "error",
            summary: "Conta não confirmada",
            detail:
              "Confirme a conta pelo WhatsApp ou e-mail antes de recuperar a senha. Use Reenviar confirmação se precisar.",
            life: 9000,
          });
          this.loading = false;
          return;
        }

        this.$toast.add({
          severity: "error",
          summary: "Ocorreu um erro.",
          detail: "Email não encontrado.",
          life: 3000,
        });
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-btn {
  color: #ffffff;
  background-color: #e41b80;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  height: 40px;
  width: 100%;
  margin-top: 15px !important;

  .btn-icon {
    font-size: 1.6em;
  }

  &:hover {
    color: #ffffff;
  }
}

.more-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

.no-campaign {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
  padding: 50px 0;
}

/* Custom modal styles */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.custom-modal-dialog {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 460px;
  width: 100%;
}

.custom-modal-content {
  padding: 20px;
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.twofa-spam-notice {
  display: flex;
  gap: 0.7rem;
  width: 100%;
  margin: 0.35rem 0 1rem;
  padding: 0.85rem 0.9rem;
  border-radius: 10px;
  border: 1px solid #f0c36d;
  background: linear-gradient(135deg, #fff8e8 0%, #fff1d2 100%);
  color: #5c4818;
  text-align: left;
}

.twofa-spam-notice__icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f59e0b;
  color: #fff;
}

.twofa-spam-notice__icon .material-icons {
  font-size: 1.15rem;
}

.twofa-spam-notice__body strong {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.86rem;
  color: #8a5a00;
}

.twofa-spam-notice__body p {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: #6b5420;
}
</style>
